import { AppBar, styled } from '@mui/material';

const NavBarAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.grey[900],
  color: theme.palette.grey[50],
  position: 'static',
}));

export default NavBarAppBar;
